import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchMaintenanceDashboardSuccess,
  fetchMaintenanceDashboardFailure,
  //
  fetchMaintenanceRequestsSuccess,
  fetchMaintenanceRequestsFailure,
  //
  addMaintenanceRequestSuccess,
  addMaintenanceRequestFailure,
  //
  fetchMaintenanceRequestSuccess,
  fetchMaintenanceRequestFailure,
  //
  editMaintenanceRequestSuccess,
  editMaintenanceRequestFailure,
  //
  deleteMaintenanceRequestSuccess,
  deleteMaintenanceRequestFailure,
  //
  updateMaintenanceRequestStatusSuccess,
  updateMaintenanceRequestStatusFailure,
  //
  fetchMaintenanceInspectionsSuccess,
  fetchMaintenanceInspectionsFailure,
  //
  addMaintenanceInspectionSuccess,
  addMaintenanceInspectionFailure,
  //
  fetchMaintenanceInspectionSuccess,
  fetchMaintenanceInspectionFailure,
  //
  submitMaintenanceInspectionSuccess,
  submitMaintenanceInspectionFailure,
  //
  fetchMaintenanceAssetsSuccess,
  fetchMaintenanceAssetsFailure,
  //
  addMaintenanceAssetSuccess,
  addMaintenanceAssetFailure,
  //
  fetchMaintenanceAssetSuccess,
  fetchMaintenanceAssetFailure,
  //
  editMaintenanceAssetSuccess,
  editMaintenanceAssetFailure,
  //
  deleteMaintenanceAssetSuccess,
  deleteMaintenanceAssetFailure,
  //
  fetchMaintenanceComplianceSuccess,
  fetchMaintenanceComplianceFailure,
  //
  addMaintenanceComplianceSuccess,
  addMaintenanceComplianceFailure,
  //
  fetchMaintenanceComplianceItemSuccess,
  fetchMaintenanceComplianceItemFailure,
  //
  editMaintenanceComplianceSuccess,
  editMaintenanceComplianceFailure,
  //
  deleteMaintenanceComplianceSuccess,
  deleteMaintenanceComplianceFailure,
  //
  fetchMaintenanceSchedulesSuccess,
  fetchMaintenanceSchedulesFailure,
  //
  addMaintenanceScheduleSuccess,
  addMaintenanceScheduleFailure,
  //
  editMaintenanceScheduleSuccess,
  editMaintenanceScheduleFailure,
  //
  deleteMaintenanceScheduleSuccess,
  deleteMaintenanceScheduleFailure,
  //
  fetchScheduleTemplatesSuccess,
  fetchScheduleTemplatesFailure,
  //
  addScheduleTemplateSuccess,
  addScheduleTemplateFailure,
  editScheduleTemplateSuccess,
  editScheduleTemplateFailure,
  deleteScheduleTemplateSuccess,
  deleteScheduleTemplateFailure,
  //
  activateAllPresetsSuccess,
  activateAllPresetsFailure,
  //
  fetchMaintenanceLocationSettingSuccess,
  fetchMaintenanceLocationSettingFailure,
  //
  saveMaintenanceLocationSettingSuccess,
  saveMaintenanceLocationSettingFailure,
  //
  fetchInspectionTemplatesSuccess,
  fetchInspectionTemplatesFailure,
  //
  addInspectionTemplateSuccess,
  addInspectionTemplateFailure,
  //
  editInspectionTemplateSuccess,
  editInspectionTemplateFailure,
  //
  deleteInspectionTemplateSuccess,
  deleteInspectionTemplateFailure,
  //
  cloneInspectionTemplateSuccess,
  cloneInspectionTemplateFailure,
  //
  addInspectionFromTemplateSuccess,
  addInspectionFromTemplateFailure,
  //
  fetchCqcReportSuccess,
  fetchCqcReportFailure,
  //
  fetchInspectionReportSuccess,
  fetchInspectionReportFailure,
  //
  fetchComplianceMatrixSuccess,
  fetchComplianceMatrixFailure,
} from "./actions";
import {
  FETCH_MAINTENANCE_DASHBOARD,
  FETCH_MAINTENANCE_REQUESTS,
  ADD_MAINTENANCE_REQUEST,
  FETCH_MAINTENANCE_REQUEST,
  EDIT_MAINTENANCE_REQUEST,
  DELETE_MAINTENANCE_REQUEST,
  UPDATE_MAINTENANCE_REQUEST_STATUS,
  FETCH_MAINTENANCE_INSPECTIONS,
  ADD_MAINTENANCE_INSPECTION,
  FETCH_MAINTENANCE_INSPECTION,
  SUBMIT_MAINTENANCE_INSPECTION,
  FETCH_MAINTENANCE_ASSETS,
  ADD_MAINTENANCE_ASSET,
  FETCH_MAINTENANCE_ASSET,
  EDIT_MAINTENANCE_ASSET,
  DELETE_MAINTENANCE_ASSET,
  FETCH_MAINTENANCE_COMPLIANCE,
  ADD_MAINTENANCE_COMPLIANCE,
  FETCH_MAINTENANCE_COMPLIANCE_ITEM,
  EDIT_MAINTENANCE_COMPLIANCE,
  DELETE_MAINTENANCE_COMPLIANCE,
  FETCH_MAINTENANCE_SCHEDULES,
  ADD_MAINTENANCE_SCHEDULE,
  EDIT_MAINTENANCE_SCHEDULE,
  DELETE_MAINTENANCE_SCHEDULE,
  FETCH_SCHEDULE_TEMPLATES,
  ADD_SCHEDULE_TEMPLATE,
  EDIT_SCHEDULE_TEMPLATE,
  DELETE_SCHEDULE_TEMPLATE,
  ACTIVATE_ALL_PRESETS,
  FETCH_MAINTENANCE_LOCATION_SETTING,
  SAVE_MAINTENANCE_LOCATION_SETTING,
  FETCH_INSPECTION_TEMPLATES,
  ADD_INSPECTION_TEMPLATE,
  EDIT_INSPECTION_TEMPLATE,
  DELETE_INSPECTION_TEMPLATE,
  CLONE_INSPECTION_TEMPLATE,
  ADD_INSPECTION_FROM_TEMPLATE,
  FETCH_CQC_REPORT,
  FETCH_INSPECTION_REPORT,
  FETCH_COMPLIANCE_MATRIX,
} from "./constants";

export function* fetchMaintenanceDashboardSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-dashboard?${query}`,
    );
    yield put(fetchMaintenanceDashboardSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceDashboardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch dashboard"));
  }
}

export function* fetchMaintenanceRequestsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-request?${query}`,
    );
    yield put(fetchMaintenanceRequestsSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceRequestsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch requests"));
  }
}

export function* addMaintenanceRequestSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceRequestSuccess());
      yield put(successAlert("Request created successfully"));
      if (history) history.push("/d/maintenance/requests");
    }
  } catch (e) {
    yield put(addMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(e?.response?.data?.message || "Failed to create request"),
      );
  }
}

export function* fetchMaintenanceRequestSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-request/${payload}`,
    );
    yield put(fetchMaintenanceRequestSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch request"));
  }
}

export function* editMaintenanceRequestSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceRequestSuccess());
      yield put(successAlert("Request updated successfully"));
      if (history) history.push("/d/maintenance/requests");
    }
  } catch (e) {
    yield put(editMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else
      yield put(
        errorAlert(e?.response?.data?.message || "Failed to update request"),
      );
  }
}

export function* deleteMaintenanceRequestSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-request/${payload?.id}`,
    );
    if (data) {
      yield put(deleteMaintenanceRequestSuccess());
      yield put(successAlert("Request deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceRequestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete request"));
  }
}

export function* updateMaintenanceRequestStatusSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-request/status/${payload?.id}`,
      payload?.data,
    );
    if (response) {
      yield put(updateMaintenanceRequestStatusSuccess());
      yield put(successAlert("Status updated successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(updateMaintenanceRequestStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update status"));
  }
}

export function* fetchMaintenanceInspectionsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection?${query}`,
    );
    yield put(fetchMaintenanceInspectionsSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceInspectionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspections"));
  }
}

export function* addMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceInspectionSuccess());
      yield put(successAlert("Inspection created successfully"));
      if (history) history.push("/d/maintenance/inspections");
    }
  } catch (e) {
    yield put(addMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create inspection"));
  }
}

export function* fetchMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection/${payload}`,
    );
    yield put(fetchMaintenanceInspectionSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection"));
  }
}

export function* submitMaintenanceInspectionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/submit/${id}`,
      data,
    );
    if (response) {
      yield put(submitMaintenanceInspectionSuccess());
      yield put(successAlert("Inspection submitted successfully"));
      if (history) history.push("/d/maintenance/inspections");
    }
  } catch (e) {
    yield put(submitMaintenanceInspectionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to submit inspection"));
  }
}

export function* fetchMaintenanceAssetsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-asset?${query}`,
    );
    const result = Array.isArray(data)
      ? { data, total: data.length, current_page: payload?.page ?? 1 }
      : { ...data, current_page: payload?.page ?? data?.current_page ?? 1 };
    yield put(fetchMaintenanceAssetsSuccess(result));
  } catch (e) {
    yield put(fetchMaintenanceAssetsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch assets"));
  }
}

export function* addMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-asset/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceAssetSuccess());
      yield put(successAlert("Asset created successfully"));
      if (typeof onSuccess === "function") onSuccess();
      else if (history) history.push("/d/maintenance/assets");
    }
  } catch (e) {
    yield put(addMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create asset"));
  }
}

export function* fetchMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id =
    typeof payload === "string" ? payload : (payload?.uuid ?? payload?.id);
  try {
    const { data } = yield call(api(token).get, `/api/maintenance-asset/${id}`);
    yield put(fetchMaintenanceAssetSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch asset"));
  }
}

export function* editMaintenanceAssetSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, uuid, onSuccess } = payload || {};
  const assetId = id ?? uuid;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-asset/edit/${assetId}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceAssetSuccess());
      yield put(successAlert("Asset updated successfully"));
      if (typeof onSuccess === "function") onSuccess();
      else if (history) history.push("/d/maintenance/assets");
    }
  } catch (e) {
    yield put(editMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update asset"));
  }
}

export function* deleteMaintenanceAssetSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(api(token).delete, `/api/maintenance-asset/${id}`);
    if (data) {
      yield put(deleteMaintenanceAssetSuccess());
      yield put(successAlert("Asset deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceAssetFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete asset"));
  }
}

export function* fetchMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-compliance?${query}`,
    );
    yield put(fetchMaintenanceComplianceSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch compliance certificates"));
  }
}

export function* addMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-compliance/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate added successfully"));
      if (history) history.push("/d/maintenance/compliance");
    }
  } catch (e) {
    yield put(addMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to add certificate"));
  }
}

export function* fetchMaintenanceComplianceItemSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-compliance/${payload}`,
    );
    yield put(fetchMaintenanceComplianceItemSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceComplianceItemFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch certificate"));
  }
}

export function* editMaintenanceComplianceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-compliance/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate updated successfully"));
      if (history) history.push("/d/maintenance/compliance");
    }
  } catch (e) {
    yield put(editMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update certificate"));
  }
}

export function* deleteMaintenanceComplianceSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-compliance/${payload?.id}`,
    );
    if (data) {
      yield put(deleteMaintenanceComplianceSuccess());
      yield put(successAlert("Certificate deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceComplianceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete certificate"));
  }
}

export function* fetchMaintenanceSchedulesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-schedule?${query}`,
    );
    yield put(fetchMaintenanceSchedulesSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceSchedulesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch schedules"));
  }
}

export function* addMaintenanceScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/add`,
      data,
    );
    if (response) {
      yield put(addMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule created successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
      if (history) history.push("/d/maintenance/schedule");
    }
  } catch (e) {
    yield put(addMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create schedule"));
  }
}

export function* editMaintenanceScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, onSuccess } = payload || {};
  const scheduleId = id ?? payload?.uuid;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/edit/${scheduleId}`,
      data,
    );
    if (response) {
      yield put(editMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule updated successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
      if (history) history.push("/d/maintenance/schedule");
    }
  } catch (e) {
    yield put(editMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update schedule"));
  }
}

export function* deleteMaintenanceScheduleSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-schedule/${id}`,
    );
    if (data) {
      yield put(deleteMaintenanceScheduleSuccess());
      yield put(successAlert("Schedule deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteMaintenanceScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete schedule"));
  }
}

export function* fetchScheduleTemplatesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-schedule-template?${query}`,
    );
    yield put(fetchScheduleTemplatesSuccess(data));
  } catch (e) {
    yield put(fetchScheduleTemplatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch schedule templates"));
  }
}

export function* addScheduleTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule-template/add`,
      data,
    );
    if (response) {
      yield put(addScheduleTemplateSuccess());
      yield put(successAlert("Schedule template created successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addScheduleTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create schedule template"));
  }
}

export function* editScheduleTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, id, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule-template/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editScheduleTemplateSuccess());
      yield put(successAlert("Schedule template updated successfully"));
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editScheduleTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update schedule template"));
  }
}

export function* deleteScheduleTemplateSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const id = payload?.id ?? payload?.uuid;
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-schedule-template/${id}`,
    );
    if (data !== undefined) {
      yield put(deleteScheduleTemplateSuccess());
      yield put(successAlert("Schedule template deleted successfully"));
      if (typeof onDelete === "function") onDelete();
    }
  } catch (e) {
    yield put(deleteScheduleTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete schedule template"));
  }
}

export function* activateAllPresetsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-schedule/activate-presets`,
      payload,
    );
    if (response) {
      yield put(activateAllPresetsSuccess());
      yield put(successAlert("Presets activated successfully"));
    }
  } catch (e) {
    yield put(activateAllPresetsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to activate presets"));
  }
}

export function* fetchMaintenanceLocationSettingSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-location-setting/${payload?.location_id}`,
    );
    yield put(fetchMaintenanceLocationSettingSuccess(data));
  } catch (e) {
    yield put(fetchMaintenanceLocationSettingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch location settings"));
  }
}

export function* saveMaintenanceLocationSettingSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/maintenance-location-setting/add`,
      payload,
    );
    yield put(saveMaintenanceLocationSettingSuccess(data));
    yield put(successAlert("Settings saved successfully"));
  } catch (e) {
    yield put(saveMaintenanceLocationSettingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to save settings"));
  }
}

export function* fetchInspectionTemplatesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection-template?${query}`,
    );
    yield put(fetchInspectionTemplatesSuccess(data));
  } catch (e) {
    yield put(fetchInspectionTemplatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection templates"));
  }
}

export function* addInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/add`,
      data,
    );
    if (response) {
      yield put(addInspectionTemplateSuccess());
      yield put(successAlert("Template created successfully"));
      if (history) history.push("/d/maintenance/inspection/templates");
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(addInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create template"));
  }
}

export function* editInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, history, id, onSuccess } = payload || {};
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/edit/${id}`,
      data,
    );
    if (response) {
      yield put(editInspectionTemplateSuccess());
      yield put(successAlert("Template updated successfully"));
      if (history) history.push("/d/maintenance/inspection/templates");
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    }
  } catch (e) {
    yield put(editInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to update template"));
  }
}

export function* deleteInspectionTemplateSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/maintenance-inspection-template/${payload?.id}`,
    );
    if (data) {
      yield put(deleteInspectionTemplateSuccess());
      yield put(successAlert("Template deleted successfully"));
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to delete template"));
  }
}

export function* cloneInspectionTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection-template/clone/${data?.id}`,
      data,
    );
    if (response) {
      yield put(cloneInspectionTemplateSuccess());
      yield put(successAlert("Template cloned successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(cloneInspectionTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to clone template"));
  }
}

export function* addInspectionFromTemplateSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/maintenance-inspection/add-from-template`,
      data,
    );
    if (response) {
      yield put(addInspectionFromTemplateSuccess());
      yield put(successAlert("Inspection created from template successfully"));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addInspectionFromTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to create inspection from template"));
  }
}

export function* fetchMaintenanceDashboardFlow() {
  yield takeEvery(FETCH_MAINTENANCE_DASHBOARD, fetchMaintenanceDashboardSaga);
}
export function* fetchMaintenanceRequestsFlow() {
  yield takeEvery(FETCH_MAINTENANCE_REQUESTS, fetchMaintenanceRequestsSaga);
}
export function* addMaintenanceRequestFlow() {
  yield takeEvery(ADD_MAINTENANCE_REQUEST, addMaintenanceRequestSaga);
}
export function* fetchMaintenanceRequestFlow() {
  yield takeEvery(FETCH_MAINTENANCE_REQUEST, fetchMaintenanceRequestSaga);
}
export function* editMaintenanceRequestFlow() {
  yield takeEvery(EDIT_MAINTENANCE_REQUEST, editMaintenanceRequestSaga);
}
export function* deleteMaintenanceRequestFlow() {
  yield takeEvery(DELETE_MAINTENANCE_REQUEST, deleteMaintenanceRequestSaga);
}
export function* updateMaintenanceRequestStatusFlow() {
  yield takeEvery(
    UPDATE_MAINTENANCE_REQUEST_STATUS,
    updateMaintenanceRequestStatusSaga,
  );
}
export function* fetchMaintenanceInspectionsFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_INSPECTIONS,
    fetchMaintenanceInspectionsSaga,
  );
}
export function* addMaintenanceInspectionFlow() {
  yield takeEvery(ADD_MAINTENANCE_INSPECTION, addMaintenanceInspectionSaga);
}
export function* fetchMaintenanceInspectionFlow() {
  yield takeEvery(FETCH_MAINTENANCE_INSPECTION, fetchMaintenanceInspectionSaga);
}
export function* submitMaintenanceInspectionFlow() {
  yield takeEvery(
    SUBMIT_MAINTENANCE_INSPECTION,
    submitMaintenanceInspectionSaga,
  );
}
export function* fetchMaintenanceAssetsFlow() {
  yield takeEvery(FETCH_MAINTENANCE_ASSETS, fetchMaintenanceAssetsSaga);
}
export function* addMaintenanceAssetFlow() {
  yield takeEvery(ADD_MAINTENANCE_ASSET, addMaintenanceAssetSaga);
}
export function* fetchMaintenanceAssetFlow() {
  yield takeEvery(FETCH_MAINTENANCE_ASSET, fetchMaintenanceAssetSaga);
}
export function* editMaintenanceAssetFlow() {
  yield takeEvery(EDIT_MAINTENANCE_ASSET, editMaintenanceAssetSaga);
}
export function* deleteMaintenanceAssetFlow() {
  yield takeEvery(DELETE_MAINTENANCE_ASSET, deleteMaintenanceAssetSaga);
}
export function* fetchMaintenanceComplianceFlow() {
  yield takeEvery(FETCH_MAINTENANCE_COMPLIANCE, fetchMaintenanceComplianceSaga);
}
export function* addMaintenanceComplianceFlow() {
  yield takeEvery(ADD_MAINTENANCE_COMPLIANCE, addMaintenanceComplianceSaga);
}
export function* fetchMaintenanceComplianceItemFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_COMPLIANCE_ITEM,
    fetchMaintenanceComplianceItemSaga,
  );
}
export function* editMaintenanceComplianceFlow() {
  yield takeEvery(EDIT_MAINTENANCE_COMPLIANCE, editMaintenanceComplianceSaga);
}
export function* deleteMaintenanceComplianceFlow() {
  yield takeEvery(
    DELETE_MAINTENANCE_COMPLIANCE,
    deleteMaintenanceComplianceSaga,
  );
}
export function* fetchMaintenanceSchedulesFlow() {
  yield takeEvery(FETCH_MAINTENANCE_SCHEDULES, fetchMaintenanceSchedulesSaga);
}
export function* addMaintenanceScheduleFlow() {
  yield takeEvery(ADD_MAINTENANCE_SCHEDULE, addMaintenanceScheduleSaga);
}
export function* editMaintenanceScheduleFlow() {
  yield takeEvery(EDIT_MAINTENANCE_SCHEDULE, editMaintenanceScheduleSaga);
}
export function* deleteMaintenanceScheduleFlow() {
  yield takeEvery(DELETE_MAINTENANCE_SCHEDULE, deleteMaintenanceScheduleSaga);
}
export function* fetchScheduleTemplatesFlow() {
  yield takeEvery(FETCH_SCHEDULE_TEMPLATES, fetchScheduleTemplatesSaga);
}
export function* addScheduleTemplateFlow() {
  yield takeEvery(ADD_SCHEDULE_TEMPLATE, addScheduleTemplateSaga);
}
export function* editScheduleTemplateFlow() {
  yield takeEvery(EDIT_SCHEDULE_TEMPLATE, editScheduleTemplateSaga);
}
export function* deleteScheduleTemplateFlow() {
  yield takeEvery(DELETE_SCHEDULE_TEMPLATE, deleteScheduleTemplateSaga);
}
export function* activateAllPresetsFlow() {
  yield takeEvery(ACTIVATE_ALL_PRESETS, activateAllPresetsSaga);
}
export function* fetchMaintenanceLocationSettingFlow() {
  yield takeEvery(
    FETCH_MAINTENANCE_LOCATION_SETTING,
    fetchMaintenanceLocationSettingSaga,
  );
}
export function* saveMaintenanceLocationSettingFlow() {
  yield takeEvery(
    SAVE_MAINTENANCE_LOCATION_SETTING,
    saveMaintenanceLocationSettingSaga,
  );
}
export function* fetchInspectionTemplatesFlow() {
  yield takeEvery(FETCH_INSPECTION_TEMPLATES, fetchInspectionTemplatesSaga);
}
export function* addInspectionTemplateFlow() {
  yield takeEvery(ADD_INSPECTION_TEMPLATE, addInspectionTemplateSaga);
}
export function* editInspectionTemplateFlow() {
  yield takeEvery(EDIT_INSPECTION_TEMPLATE, editInspectionTemplateSaga);
}
export function* deleteInspectionTemplateFlow() {
  yield takeEvery(DELETE_INSPECTION_TEMPLATE, deleteInspectionTemplateSaga);
}
export function* cloneInspectionTemplateFlow() {
  yield takeEvery(CLONE_INSPECTION_TEMPLATE, cloneInspectionTemplateSaga);
}
export function* addInspectionFromTemplateFlow() {
  yield takeEvery(ADD_INSPECTION_FROM_TEMPLATE, addInspectionFromTemplateSaga);
}

export function* fetchCqcReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/cqc?${query}`,
    );
    yield put(fetchCqcReportSuccess(data));
  } catch (e) {
    yield put(fetchCqcReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch CQC report"));
  }
}

export function* fetchComplianceMatrixSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-report/compliance-matrix?${query}`,
    );
    yield put(fetchComplianceMatrixSuccess(data));
  } catch (e) {
    yield put(fetchComplianceMatrixFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch compliance matrix"));
  }
}

export function* fetchCqcReportFlow() {
  yield takeEvery(FETCH_CQC_REPORT, fetchCqcReportSaga);
}

export function* fetchInspectionReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/maintenance-inspection/${id}/report`,
    );
    yield put(fetchInspectionReportSuccess(data));
  } catch (e) {
    yield put(fetchInspectionReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Failed to fetch inspection report"));
  }
}

export function* fetchInspectionReportFlow() {
  yield takeEvery(FETCH_INSPECTION_REPORT, fetchInspectionReportSaga);
}

export function* fetchComplianceMatrixFlow() {
  yield takeEvery(FETCH_COMPLIANCE_MATRIX, fetchComplianceMatrixSaga);
}

export default function* MaintenanceSaga() {
  yield all([
    fetchMaintenanceDashboardFlow(),
    fetchMaintenanceRequestsFlow(),
    addMaintenanceRequestFlow(),
    fetchMaintenanceRequestFlow(),
    editMaintenanceRequestFlow(),
    deleteMaintenanceRequestFlow(),
    updateMaintenanceRequestStatusFlow(),
    fetchMaintenanceInspectionsFlow(),
    addMaintenanceInspectionFlow(),
    fetchMaintenanceInspectionFlow(),
    submitMaintenanceInspectionFlow(),
    fetchMaintenanceAssetsFlow(),
    addMaintenanceAssetFlow(),
    fetchMaintenanceAssetFlow(),
    editMaintenanceAssetFlow(),
    deleteMaintenanceAssetFlow(),
    fetchMaintenanceComplianceFlow(),
    addMaintenanceComplianceFlow(),
    fetchMaintenanceComplianceItemFlow(),
    editMaintenanceComplianceFlow(),
    deleteMaintenanceComplianceFlow(),
    fetchMaintenanceSchedulesFlow(),
    addMaintenanceScheduleFlow(),
    editMaintenanceScheduleFlow(),
    deleteMaintenanceScheduleFlow(),
    fetchScheduleTemplatesFlow(),
    addScheduleTemplateFlow(),
    editScheduleTemplateFlow(),
    deleteScheduleTemplateFlow(),
    activateAllPresetsFlow(),
    fetchMaintenanceLocationSettingFlow(),
    saveMaintenanceLocationSettingFlow(),
    fetchInspectionTemplatesFlow(),
    addInspectionTemplateFlow(),
    editInspectionTemplateFlow(),
    deleteInspectionTemplateFlow(),
    cloneInspectionTemplateFlow(),
    addInspectionFromTemplateFlow(),
    fetchCqcReportFlow(),
    fetchInspectionReportFlow(),
    fetchComplianceMatrixFlow(),
  ]);
}
